import { Pipe, PipeTransform } from '@angular/core';
import { SelectedItem } from 'src/app/controls/models/selected-item.interface';

@Pipe({
  name: 'selector',
  standalone: true,
})
export class ItemListSelectorPipe implements PipeTransform {
  transform(
    value: SelectedItem[],
    items: SelectedItem[],
    updated: Date,
  ): SelectedItem[] {
    if (!value || !value.length || !items || !items.length || !updated) {
      return value;
    }

    /** converts items list to set */
    const itemsSet = new Set(items.map(obj => obj.value));

    return value.filter(obj => !itemsSet.has(obj.value));
  }
}
